import React from "react";
import styles from "./NotificationModal.module.scss";
import Button from "../elements/Button/Button"; // Add some styles for the modal

const NotificationModal = ({ message, isOpen, onClose, onAction }) => {
    return (
        isOpen && (
            <div className={styles.overlay}>
                <div className={styles.content}>
                    <h2>Error appeared</h2>
                    <p>{message}</p>
                    <div className={styles.buttonContainer}>
                        <Button onClick={onClose} className="secondary">
                            Close
                        </Button>
                    </div>
                </div>
            </div>
        )
    );
};

export default NotificationModal;
